<template>
    <div v-loading.fullscreen.lock="state.fullLoading" element-loading-background="rgba(0, 0, 0, 0.3)">
        <el-card class="box-card" :body-style="{ padding: '8px' }">
            <el-page-header content="订单记录" :icon="null" title="订单管理">
                <template #extra>
                    <el-button type="primary" @click="searchFun(1)">刷新</el-button>
                    <el-button @click="searchFun(2)">重置</el-button>
                </template>
            </el-page-header>
            <el-table :data="tableData" border style="width: 100%;margin-top: 8px;" height="calc(100vh - 193px)"
                row-key="id" v-loading="state.tableLoading">
                <el-table-column prop="type" label="评估类型" min-width="100px" />
                <el-table-column prop="vin" label="车架号" min-width="190px">
                    <template #header>
                        <div class="header-cell" :class="{ 'header-cell_active': search.vin }">
                            <span>车架号</span>
                            <el-icon ref="triggerRefVin">
                                <Filter />
                            </el-icon>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="userPhone" label="手机号码" min-width="120px">
                    <template #header>
                        <div class="header-cell" :class="{ 'header-cell_active': search.userPhone }">
                            <span>手机号码</span>
                            <el-icon ref="triggerRefUserPhone">
                                <Filter />
                            </el-icon>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="paymentAmount" label="支付金额（元）" min-width="150px">
                    <template #header>
                        <div class="header-cell" :class="{ 'header-cell_active': search.paymentAmount }">
                            <span>支付金额（元）</span>
                            <el-icon ref="triggerRefPaymentAmount">
                                <Filter />
                            </el-icon>
                        </div>
                    </template>
                    <template #default="scope">
                        <el-text class="mx-1" type="primary">
                            {{ formatCurrency(scope.row.paymentAmount / 100, 2, '.', ',') }}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column prop="rateAmt" label="折扣金额（元）" min-width="150px">
                    <template #default="scope">
                        <el-text class="mx-1" type="primary">
                            {{ formatCurrency(scope.row.rateAmt / 100, 2, '.', ',') }}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column prop="commissionDiscount" label="减免佣金（元）" min-width="150px">
                    <template #default="scope">
                        <el-text class="mx-1" type="primary">
                            {{ formatCurrency(scope.row.commissionDiscount / 100, 2, '.', ',') }}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column prop="balanceDiscount" label="减免余额（元）" min-width="150px">
                    <template #default="scope">
                        <el-text class="mx-1" type="primary">
                            {{ formatCurrency(scope.row.balanceDiscount / 100, 2, '.', ',') }}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column prop="orderStatus" label="订单状态" min-width="130px">
                    <template #header>
                        <div class="header-cell" :class="{ 'header-cell_active': search.orderStatus }">
                            <span>订单状态</span>
                            <el-icon ref="triggerRefOrderStatus">
                                <Filter />
                            </el-icon>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="支付时间" min-width="180px">
                    <template #header>
                        <div class="header-cell" :class="{ 'header-cell_active': search.daterange }">
                            <span>支付时间</span>
                            <el-icon @click="dateRangeFilter" ref="triggerRefDaterange">
                                <Filter />
                            </el-icon>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="createType" label="创建方式" min-width="130px" />
                <el-table-column prop="tradeNo" label="支付订单" min-width="300px">
                    <template #header>
                        <div class="header-cell" :class="{ 'header-cell_active': search.tradeNo }">
                            <span>支付订单</span>
                            <el-icon ref="triggerRefTradeNo">
                                <Filter />
                            </el-icon>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="outTradeNo" label="外部支付单号" min-width="280px" />
            </el-table>
            <div class="pagination-box">
                <el-pagination background layout="total,sizes,prev, pager, next"
                    v-model:current-page="pagination.current" v-model:page-size="pagination.size"
                    :total="pagination.total" :page-sizes="pagination.sizes" :page-size="pagination.size"
                    prev-text="上一页" next-text="下一页" @current-change="intTableData" @size-change="intTableData" />
                <div style="clear: both;"></div>
            </div>
        </el-card>
    </div>
    <!-- 筛选popover -->
    <FilterPhone @handleSearch="handleSearch" :triggerRef="triggerRefUserPhone" field="userPhone" :formValue="search" />
    <FilterText @handleSearch="handleSearch" :triggerRef="triggerRefTradeNo" field="tradeNo" :formValue="search"
        placeholder="请输入订单号" />
    <FilterSelect @handleSearch="handleSearch" :triggerRef="triggerRefOrderStatus" field="orderStatus"
        :formValue="search" :options="state.options" placeholder="请选择订单状态" />
    <FilterText @handleSearch="handleSearch" :triggerRef="triggerRefVin" field="vin" :formValue="search"
        placeholder="请输入车架号" />
    <FilterText @handleSearch="handleSearch" :triggerRef="triggerRefPaymentAmount" field="paymentAmount"
        :formValue="search" placeholder="请输入支付金额" />
    <FilterDateRange @handleSearch="handleSearch" ref="popoverRefDaterange" :triggerRef="triggerRefDaterange"
        field="daterange" :formValue="search" />
</template>
<script setup>
import { reactive, ref, onMounted } from "vue";
import { Filter } from '@element-plus/icons-vue'
import { getConsumptionListFun } from "@/api/consumption"
import { formatCurrency } from "@/util/formValidator";
import FilterPhone from '@/components/TableFilter/FilterPhone.vue'
import FilterText from '@/components/TableFilter/FilterText.vue'
import FilterSelect from '@/components/TableFilter/FilterSelect.vue'
import FilterDateRange from '@/components/TableFilter/FilterDateRange.vue'

const triggerRefUserPhone = ref();// 手机号筛选ref
const triggerRefTradeNo = ref();// 订单号筛选ref
const triggerRefOrderStatus = ref();// 订单状态筛选ref
const triggerRefVin = ref();// 车架号筛选ref
const triggerRefPaymentAmount = ref();// 支付金额筛选ref
const triggerRefDaterange = ref();// 支付时间筛选
const popoverRefDaterange = ref();// 支付时间筛选

const search = reactive({
    userPhone: "",
    tradeNo: "",
    orderStatus: "",
    vin: '',
    paymentAmount: "",
    daterange: '',
})
const state = reactive({
    fullLoading: false,
    tableLoading: false,
    options: [
        { label: "已支付", value: '已支付' },
        { label: "等待支付", value: '等待支付' },
        { label: "已退款", value: '已退款' },
    ],
})
const tableData = ref([]);
const pagination = reactive({
    current: 1,
    size: 20,
    total: 0,
    sizes: [20, 50, 100]
});
// 时间日期筛选点击
const dateRangeFilter = () => {
    popoverRefDaterange.value.state.visible = !popoverRefDaterange.value.state.visible;
}
// 列表查询
const handleSearch = () => {
    searchFun(1);
}
// 查询 1查询 2重置
const searchFun = (type) => {
    popoverRefDaterange.value.state.visible = false;
    if (type == 2) {
        search.userPhone = '';
        search.tradeNo = '';
        search.paymentAmount = '';
        search.daterange = '';
        search.vin = '';
        search.orderStatus = '';
    }
    pagination.current = 1;
    intTableData();
}
// 获取表格数据
const intTableData = async () => {
    state.tableLoading = true;
    const params = {
        keys: ['current', 'size'],
        formValue: {
            current: pagination.current,
            size: pagination.size,
        }
    }

    for (let key in search) {
        if (search[key] || search[key] === 0) {
            if (key == 'daterange') {
                params.formValue['startTime'] = search[key][0];
                params.formValue['endTime'] = search[key][1];
                params.keys.push('startTime');
                params.keys.push('endTime');
            } else if (key == 'paymentAmount') {
                params.formValue['paymentAmount'] = Number(search[key]) * 100;
                params.keys.push('paymentAmount');
            } else {
                params.keys.push(key);
                params.formValue[key] = search[key];
            }
        }
    }
    getConsumptionListFun(params).then((res) => {
        tableData.value = res.data.records;
        pagination.total = res.data.total;
    }).finally(() => {
        state.tableLoading = false;
    });
}
onMounted(() => {
    intTableData();
});
</script>
<style lang="scss" scoped>
:deep .el-card {
    box-shadow: none !important;
    border-radius: inherit;
    border: none;
}

.pagination-box {
    text-align: right;
}

.el-pagination {
    margin-top: 8px;
    float: right;
}


.dialog-content {
    height: 65vh;
}

.header-cell {
    width: 100%;
    position: relative;

    :deep .el-icon {
        position: absolute;
        right: 0;
        font-size: 16px;
        line-height: 23px;
        font-weight: bold;
        display: inline-block;
        cursor: pointer;
        transition: all 0.2s;

        svg {
            height: 23px;
        }
    }

    :deep .el-icon:hover {
        color: #409eff;
    }
}

.header-cell_active {
    :deep .el-icon {
        color: #409eff;
    }
}
</style>